// For IE11 support
import { enableES5 } from 'immer';
enableES5();

import produce from 'immer';
import { TICKET_MGMT_TYPES } from '@constants/actionTypes/ticketMgmtActionTypes';

export const INITIAL_STATE = {
    loaded: false,
    entities: [],
    options: {
        optionsLoaded: false,
        workflowTypes: [],
        workgroups: [],
        permissions: []
    },
    isFormOpen: false,
    isDrawerOpen: false,
    ticketTypeFormMessage: '',
    ticketDetails: null,
    isFormDirty: false,
    categorySuccessMsg: '',
    showTktCategoryNavigation: false,
};

export default produce((draft = INITIAL_STATE, action = {}) => {
    const { type, workflowTypes, workgroups, permissions, workflowsByCategory, isFormOpen, isDrawerOpen, ticketTypeFormMessage, ticketDetails, isFormDirty, categorySuccessMsg, showTktCategoryNavigation } = action;
    switch (type) {
        case TICKET_MGMT_TYPES.GET_WORKFLOWS_BY_CATEGORY:
            draft.loaded = true;
            draft.entities = workflowsByCategory;
            break;
        case TICKET_MGMT_TYPES.EMPTY_TICKET_TYPE_SELECTION_RESULTS:
            draft.entities = workflowsByCategory;
            break;
        case TICKET_MGMT_TYPES.GET_WORKFLOW_TYPES:
            draft.options.optionsLoaded = true;
            draft.options = { ... draft.options, workflowTypes };
            break;

        case TICKET_MGMT_TYPES.GET_WORKGROUPS:
            draft.options = { ... draft.options, workgroups };
            break;

        case TICKET_MGMT_TYPES.GET_PERMISSIONS:
            draft.options = { ... draft.options, permissions };
            break;

        case TICKET_MGMT_TYPES.OPEN_TICKET_TYPE_FORM: 
            draft.isFormOpen = isFormOpen;
            break;
        case TICKET_MGMT_TYPES.OPEN_TICKET_DETAILS_DRAWER:
            draft.isDrawerOpen = isDrawerOpen;
            break;
        case TICKET_MGMT_TYPES.SHOW_SUCCESS_MESSAGE:
            draft.ticketTypeFormMessage = ticketTypeFormMessage;
            break;
        case TICKET_MGMT_TYPES.EDIT_TICKET_TYPE_RECORD:
            draft.ticketDetails = ticketDetails;
            break;
        case TICKET_MGMT_TYPES.SELECT_CATEGORY:
            draft.loaded = false;
            draft.entities = [];
            break;
        case TICKET_MGMT_TYPES.TICKET_TYPE_FORM_STATE:
            draft.isFormDirty = isFormDirty;
            break;
        case TICKET_MGMT_TYPES.SHOW_CATEGORY_SUCCESS_MSG:
            draft.categorySuccessMsg = categorySuccessMsg;
            break;
        case TICKET_MGMT_TYPES.SHOW_TICKET_CATEGORY_NAVIGATION:
            draft.showTktCategoryNavigation = showTktCategoryNavigation;
            break;
        default:
            return draft;
    }
});